import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Editor } from '@tiptap/core';
import { SuggestionProps } from '@tiptap/suggestion';
import uuid from 'short-unique-id';
import { ItemSelectionComponent } from '../item-selection';
import { EditorEmitterService } from 'app/main/pages/events/editor-emitter.service';
import { TemplateType } from 'app/main/pages/templates/template.dto';
import { Type } from './command-type-enum';
@Component({
  selector: 'app-slash-command',
  templateUrl: './slash-command.component.html',
  styleUrl: './slash-command.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SlashCommandComponent extends ItemSelectionComponent{
  @Input()
  set _props(value: SuggestionProps){
    this.props = value;

    // check whether current template is a template document
    const isTemplateDocument = this.editorEmitterService.getCurrentTemplateType() === TemplateType.TEMPLATEDOCUMENT;

    // be defensive in case items is not an array
    const items = Array.isArray(this.props?.items) ? [...this.props.items] : [];

    // filter depending on isTemplateDocument
    let filteredItems;

    if (isTemplateDocument) {
      // WHEN true: show InternalLinking items ALONG WITH other items (no filtering)
      filteredItems = items;
    } else {
      // WHEN false: exclude InternalLinking items from the array
      filteredItems = items.filter((item) => {
        const t = item?.type;
        const isInternalLinking = t === Type.InternalLinking;
        // if you use a Type enum, use: item?.type === Type.InternalLinking
        return !isInternalLinking;
      });
    }
    this.props.items = filteredItems;
    // set filtered items to selection
    this.setItems(filteredItems);
  }
  get _props() {
    return this.props;
  }
  @Input()
  set _editor(value: Editor){
    this.editor = value;
  }
  get _editor() {
    return this.editor;
  }
  public uuid = new uuid({ length: 6, dictionary: 'number' });
  constructor(private editorEmitterService: EditorEmitterService){
    super()
  }
  public props:SuggestionProps;
  public editor: Editor;

  selectItem(index: number) {
    const item = this.props.items[index];
    if (item) {
      this.props.command(item);
    }
  }

  onKeyDown({ event }) {
    if (event.key === 'ArrowUp') {
      this.upHandler();
      return true;
    }

    if (event.key === 'ArrowDown') {
      this.downHandler();
      return true;
    }

    if (event.key === 'Enter') {
      this.enterHandler();
      return true;
    }

    return false;
  }
}
